import { Booking } from "./Booking";
import { Operator } from "./Operator";
import { TableBlock } from "./TableBlocks";

export enum EventType {
  Save,
  StatusChange,
  OverrideAndSpill,
  Rerun,
  AddToWaitlist,
  RemoveOnHold,
  Update,
  CreatePayment,
  SwapBookings,
  Swap,
  Transfer,
  StandBy,
  Cancel,
  Message,
  OnHold,
  SMSNotifyStandBy,
  SaveQRBooking,
  SaveQR,
  SaveGuests,
  CloseTab,
  SaveQRGuest,
  Availability,
  AddTableBlock,
  RemoveTableBlock,
  AreaFlips,
  PaxLimits,
  SaveExclusive,
  BookingCashPayment,
  MealCashPayment,
  RestaurantCashPayment,
  UpdateSeatingLock,
  AI,
  AvailableSwaps,
}

export enum ProductEventActionType {
  RenameProduct,
  RenameProductGroup,
  ChangeProductGroup,
  AddProduct,
  DisableProduct,
  EnableProduct,
  AddProductGroup,
  EnableProductGroup,
  DisableProductGroup,
  AddProductInMenuHeading,
  DeleteProductInMenuHeading,
}

export type ProductLog = {
  action: ProductEventActionType;
  productGroupId: string;
  timestamp: number;
  productId?: string;
  read: boolean;
} & (DefaultMetadata | RenameProductOrGroupMetadata | ChangeProductGroupMetadata | ChangeProductInMenuHeadingMetaData);

type DefaultMetadata = {
  action: Exclude<ProductEventActionType, ProductEventActionType.RenameProduct | ProductEventActionType.RenameProductGroup | ProductEventActionType.ChangeProductGroup | ProductEventActionType.AddProductInMenuHeading | ProductEventActionType.DeleteProductInMenuHeading>;
  metadata: {
    newName: string;
  };
};

type RenameProductOrGroupMetadata = {
  action: ProductEventActionType.RenameProduct | ProductEventActionType.RenameProductGroup;
  metadata: {
    newName: string;
    oldName: string;
  };
};

type ChangeProductGroupMetadata = {
  action: ProductEventActionType.ChangeProductGroup;
  metadata: {
    newName: string;
    group1: string;
    group2: string;
  };
};

type ChangeProductInMenuHeadingMetaData = {
  action: ProductEventActionType.AddProductInMenuHeading | ProductEventActionType.DeleteProductInMenuHeading;
  metadata: {
    name: string;
    menuHeadingId: string;
    path: string;
    associatedData: any;
    menuHeading: any;
    newMenuHeading: any;
    message: string;
  };
};

export type EventLog = TableBlockLog | BookingLog;

export type TableBlockLog = {
  type: EventType.AddTableBlock | EventType.RemoveTableBlock;
  eventTimestamp: {
    seconds: number;
    nanoseconds: number;
  };
  date: number;
  restaurantId: string;
  mealId: string;
  tableBlock: TableBlock;
  blockId: string;
  operator: Operator;
};

export type BookingLog = {
  type: Exclude<EventType, EventType.AddTableBlock | EventType.RemoveTableBlock>;
  eventTimestamp: {
    seconds: number;
    nanoseconds: number;
  };
  booking: Booking;
  bookingId: string;
  restaurantId: string;
  status: number;
  date: number;
  operatorId: string;
  operatorName?: string;
};
